var _path;
import * as React from "react";
function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.331 12.27a4.02 4.02 0 00-2.829-2.847C30.007 8.75 20 8.75 20 8.75s-10.007 0-12.502.673a4.02 4.02 0 00-2.83 2.848C4 14.782 4 20.023 4 20.023s0 5.24.669 7.752c.368 1.386 1.452 2.432 2.829 2.802C9.993 31.25 20 31.25 20 31.25s10.007 0 12.502-.673c1.377-.37 2.461-1.416 2.83-2.802.668-2.512.668-7.752.668-7.752s0-5.24-.669-7.752zM16.727 24.78v-9.515l8.364 4.758-8.364 4.758z"
  })));
}
export default SvgYoutube;